export default class {
    constructor ($timeout, $q) {
        this.$timeout = $timeout;
        this.$q = $q;
    }

    /**
     * Wraps an async function with debounce + minimum-length guard.
     *
     * @param {Function} fn        - Async function to debounce; must return a promise.
     * @param {Object}   [options]
     * @param {number}   [options.minLength=3] - Minimum query length before firing.
     * @param {number}   [options.delay=500]   - Debounce delay in milliseconds.
     * @returns {Function} Debounced version of `fn`.
     */
    create (fn, { delay = 500 } = {}) {
        let pending = null;

        return (query) => {
            const deferred = this.$q.defer();

            if (pending) {
                this.$timeout.cancel(pending);
            }

            pending = this.$timeout(() => {
                this.$q.when(fn(query)).then(deferred.resolve, deferred.reject);
            }, delay);

            return deferred.promise;
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/services/debounce/index.js